import { types } from 'mobx-state-tree';

const LocalizationSites = types.model('GeoIpSites', {
  domain: types.string,
  recommendedForCountry: types.maybeNull(types.boolean),
  shipsToCountry: types.maybeNull(types.boolean)
});

export default LocalizationSites;
